/**
 * Экспорт всех composables для работы с доставкой
 */

export { useFastDeliveryCookie } from './useFastDeliveryCookie.ts';
export { useFastDeliveryStatus, DeliveryStatus } from './useFastDeliveryStatus.ts';
export { usePickupPointCookie } from './usePickupPointCookie.ts';

export type {
    IDeliveryAddress,
    IFastDeliveryState,
    IAddressUpdateParams,
    IDeliveryAvailabilityResult,
    ISetDeliveryDataParams,
    IPickupPointState,
} from '../../types/delivery.ts';

export type {
    ICoordinates,
} from '../../types/map.ts';

export {
    DELIVERY_TYPES,
    DELIVERY_COOKIES,
    DELIVERY_API_PARAMS,
    DELIVERY_API_ENDPOINTS,
    COOKIE_EXPIRY,
    DELIVERY_TEXTS,
    ERROR_MESSAGES,
} from '../../constants/delivery.ts';

